import React from 'react'
import { useLocation, Outlet, Navigate } from 'react-router-dom';
import { knownPaths } from 'components/Auth';
import { setSessionFlag } from 'hooks/useSessionFlag/useSessionFlag';

interface AuthLayoutProps {
    authenticated: boolean
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ authenticated }) => {
    const location = useLocation();
    if (!authenticated && (!knownPaths.includes(location.pathname) || location.search || location.hash)) {
        setSessionFlag('expired-url', `${location.pathname}${location.search}${location.hash}`);
    }

    return (authenticated
        ? <Outlet />
        : <Navigate to="/login" state={{ from: location }} />);
};